import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import languageReducer from './language/reducer';

const reducer = combineReducers({
   languageR: languageReducer,
});

export const store = configureStore({ reducer });
